import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const authToken = localStorage.getItem('authToken');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
  
    const toggleMenu = () => {
      setIsMenuOpen(prev => !prev);
    };

    // Logout function
    const handleLogout = () => {
        localStorage.removeItem('authToken');
        navigate('/'); // redirect to login page
      };
    

  const handlePasswordChange = async () => {
    setMessage('');

    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage('Please fill in all fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('New passwords do not match.');
      return;
    }

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/update_password/', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          registration: true,
          old_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage(result.message || 'Password changed successfully!');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');

             // Wait 2 seconds to show success message, then logout
             setTimeout(() => {
                handleLogout();
              }, 2000);
      } else {
        setMessage(result.error || 'Failed to change password.');
      }
    } catch (error) {
      setMessage('An error occurred while changing password.');
    }
  };

  return (
    <>
    <div className="headerTop">
    <img src="/assets/Flowlogic-Logo.svg" alt="FlowLogic Icon" />

    <div className="headerRightOuter">
      <div className="headerRight">
        <div className="profilePic">
          <img src="/assets/Profile-pic.png" alt="Profile" />
        </div>

        <nav className="navbar">
          <div
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
          >
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
          </div>

          <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <ul>
             {/* <li><a href="/dashboard">Home</a></li> */}
             <li><a href="/points">Home</a></li>
              {/* <li><a href="/profile">Manage</a></li> */}
              <li><a href="/manage">Profile</a></li>
              <li><a href="/change-password">Password</a></li>
              <li><a href="#">Notifications</a></li>
              <li><a href="#" onClick={handleLogout}>Logout</a></li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
    <div className="change-password register-container">
      <h2>Change Password</h2>
      {message && <div className="error mb-3">{message}</div>}

      <div className="form-group">
        <label>Old Password</label>
        <input
          type="password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>New Password</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Confirm New Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>

      {/* <Button variant="primary" onClick={handlePasswordChange}>Change Password</Button> */}
      <Button type="submit" variant="success" className="mt-3" onClick={handlePasswordChange}>Change Password</Button>
    </div>
    </>
  );
};

export default ChangePassword;
